import './App.scss';

import MusicPlayerCard from "./components/playing_card/MusicPlayerCard";
function App() {
  return (
    <div className="App">
      <MusicPlayerCard/>
    </div>
  );
}

export default App;
